/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-alert */
import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import moment from 'moment'
import { Segment, Table, Button, Label, Modal, Popup } from 'semantic-ui-react'
import styled from 'styled-components'

import utils from '../../utils'

import ExpressActions from '../../reducers/expressReducer'

import DateRangeField from './components/ExpressCODDateField'
import timeFromNow from './components/TimeFromNow'
import ExpressRow from '../express/components/ExpressRow'

const Price = styled.div`
  font-weight: bold;
  color: rgb(208, 62, 62);
`

class ExpressCOD extends React.PureComponent {
  downloadLinkRef = React.createRef()

  state = {
    startFrom: Number(
      moment()
        .startOf('day')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('day')
        .format('x')
    ),
    refunded: false,
    loadingIds: [],
    downloading: false,
    downloadUrl: '',
    modalOrderDetailVisible: false,
    viewOrder: null,
  }

  setStateAsync = state => new Promise(resolve => this.setState(state, resolve))

  onRefund = async order => {
    try {
      const { setSingleCodReport } = this.props

      await this.setStateAsync(({ loadingIds }) => ({ loadingIds: loadingIds.concat(order.id) }))

      await firebase.firestore().collection('express_orders').doc(order.id).update({
        refunded: true,
        refunded_at: Date.now(),
      })

      await this.setStateAsync(({ loadingIds }) => ({ loadingIds: loadingIds.filter(id => id !== order.id) }))

      setSingleCodReport({ ...order, refunded: true, refunded_at: Date.now() })
    } catch (e) {
      alert(e.message)
    }
  }

  getReportByDate = () => {
    const { getCodReport } = this.props
    const { startFrom, endAt, refunded } = this.state

    getCodReport({ startFrom, endAt, refunded })
  }

  onDateChange = (field, value) => {
    this.setState({ [field]: value })
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  onSearch = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.getReportByDate()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  calculateCollectPayment = order => {
    let collectPayment = 0

    const receivers = Object.values(order.receivers || {})

    receivers.forEach(receiver => {
      if (receiver.status === 'delivered') collectPayment += receiver.collect_payment
    })

    return parseFloat(collectPayment).toFixed(2)
  }

  viewOrderDetail = order => {
    this.setState({
      modalOrderDetailVisible: true,
      viewOrder: order,
    })
  }

  onDownloadClick = async () => {
    const { expressOrders } = this.props

    const sortedOrders = _.sortBy(expressOrders, 'created_at')
    const csvString = await this.generateCSV(sortedOrders)

    const snapshot = await this.uploadFile(csvString)
    this.downloadFile(snapshot)
  }

  generateCSV = async orders => {
    let csvString = ''
    const headers = [
      'No.',
      'Customer Name',
      'Customer Tel',
      'Bank Account Name',
      'Bank Account Number',
      'Amount',
      'Date Time',
      'Settlement Status'
    ].join(', ')

    csvString = csvString.concat(`${headers} \n`)

    _.forEach(orders, (order, key) => {
      const cod = this.calculateCollectPayment(order)

      if (Number(cod) === 0) return

      const rowString = [
        key + 1,
        order.requestor.name,
        order.requestor.phone,
        order.bank_account_name,
        `'${order.bank_account_number}`,
        `$${cod}`,
        moment(order.created_at).format('DD MMMM YYYY - h:mma'),
        order.refunded ? 'Paid' : 'Unpaid'
      ]

      csvString = csvString.concat(`${rowString} \n`)
    })

    return csvString
  }

  uploadFile = async csvString => {
    const { startFrom, endAt } = this.state

    const storage = firebase
      .storage()
      .ref()
      .child(`report/express-COD-${moment(startFrom).format('YYYY-MMM-DD')}-to-${moment(
        endAt
      ).format('YYYY-MMM-DD')}.csv`)

    this.setState({ downloading: true })

    return storage.putString(csvString.toString())
  }

  downloadFile = snapshot => {
    const self = this
    snapshot.ref.getDownloadURL().then(downloadUrl => {
      self.setState({ downloading: false, downloadUrl }, () => {
        self.downloadLinkRef.click()
      })
    })
  }

  renderNoDataRow = () => {
    return (
      <Table.Row>
        <Table.Cell colSpan={6} textAlign="center">
          No Data available
        </Table.Cell>
      </Table.Row>
    )
  }

  renderPaidPopup = ({ refunded_at: refundedAt }) => (
    <Popup
      trigger={
        <Label
          content="Paid"
          color="green"
          style={{ cursor: 'pointer', padding: '.78571429em 1.5em .78571429em', fontSize: '.78571429rem' }}
        />
      }
      position="top left"
      hideOnScroll
      wide="very"
      on="click"
      content={refundedAt ? timeFromNow(refundedAt) : 'N/A'}
    />
  )

  renderRow = order => {
    const { loadingIds } = this.state
    const {
      id,
      refunded,
      requestor,
      deliverer,
      deliverer_name: delivererName,
      sender_phone: senderPhone,
      created_at: createdAt,
      bank_account_name: accountName,
      bank_account_number: accountNumber
    } = order

    const loading = loadingIds.includes(order.id)
    const cod = this.calculateCollectPayment(order)

    if (Number(cod) === 0) return null

    return (
      <Table.Row key={id}>
        <Table.Cell textAlign="center">{utils.order.getExpressOrderNumber(senderPhone, id)}</Table.Cell>
        <Table.Cell textAlign="center">{timeFromNow(createdAt)}</Table.Cell>
        <Table.Cell textAlign="center">{requestor.name}</Table.Cell>
        <Table.Cell textAlign="center">{requestor.phone}</Table.Cell>
        <Table.Cell textAlign="center">
          {delivererName}
          <br />
          {deliverer}
        </Table.Cell>
        <Table.Cell textAlign="center">
          {accountName} <br /> {accountNumber}
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Price>$ {cod}</Price>
        </Table.Cell>
        <Table.Cell textAlign="center">
          {refunded
            ? this.renderPaidPopup(order)
            : (
              <Button
                size="mini"
                content="Pay Now"
                loading={loading}
                disabled={loading}
                onClick={() => this.onRefund(order)}
              />
            )
          }
          <Button
            size="mini"
            content="View Detail"
            onClick={() => this.viewOrderDetail(order)}
          />
        </Table.Cell>
      </Table.Row>
    )
  }

  renderModal = () => {
    const { modalOrderDetailVisible, viewOrder } = this.state
    return (
      <Modal
        open={modalOrderDetailVisible}
        style={{ marginTop: 0, width: '90vw' }}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>Order Detail</Modal.Header>
        <Modal.Content style={{ padding: 0 }}>
          <Segment style={{ padding: 0, boxShadow: 'none', border: '0px', minHeight: 50 }}>
            {viewOrder && (
              <Table basic style={{ marginTop: 0 }}>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell style={{ width: '20%' }} textAlign='left' key='Sender / Receiver'>
                      Sender / Receiver
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{ width: '20%' }} textAlign='center' key='Driver / Location'>
                      Driver / Location
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{ width: '20%' }} textAlign='center' key='Payment'>
                      Payment
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{ width: '20%' }} textAlign='center' key='Payment'>
                      Ordered At
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{ width: '20%' }} textAlign='center' key='Status / Actions'>
                      Status / Actions
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  <ExpressRow
                    order={utils.order.getExpressOrderSummary(viewOrder)}
                    readOnly
                  />
                </Table.Body>
              </Table>
            )}
          </Segment>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setState({ modalOrderDetailVisible: false, viewOrder: null })}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }

  render() {
    const { expressOrders, loading } = this.props
    const { startFrom, endAt, downloading, downloadUrl, refunded } = this.state

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        <div style={{ padding: '0px 14px' }}>
          <DateRangeField
            loading={loading}
            startFrom={startFrom}
            endAt={endAt}
            onSearch={this.onSearch}
            onDateChange={this.onDateChange}
            refunded={refunded}
            onRefundChange={() => this.setState({ refunded: !refunded })}
          />

          <Button disabled={expressOrders.length === 0} loading={downloading} onClick={this.onDownloadClick} style={{ marginLeft: 5 }}>
            Download Report
          </Button>
          <a href={downloadUrl} ref={ref => { this.downloadLinkRef = ref }} style={{ display: 'none' }} />

          <div style={{ marginBottom: 15 }} />

          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center">Order Number</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">DateTime</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Customer Name</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Customer Tel</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Driver</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Bank Account</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Amount</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{expressOrders.length > 0 ? expressOrders.map(this.renderRow) : this.renderNoDataRow()}</Table.Body>
          </Table>
          {this.renderModal()}
        </div>
      </Segment>
    )
  }
}

const mapState = ({ express }) => ({
  expressOrders: Object.values(express.codReport),
  loading: express.codLoading,
})

const mapDispatch = {
  getCodReport: ExpressActions.getCodReport,
  setSingleCodReport: ExpressActions.setSingleCodReport,
}

export default connect(mapState, mapDispatch)(ExpressCOD)



// WEBPACK FOOTER //
// ./src/containers/reports/expressCOD.js